/**
 * Import Dependency
 */
import * as types from '../../mutations_types'

/**
 * Import API
 */
import heinzAPI from '@appservices/api/app/heinz'

/**
 * Declare Variable
 */
const state = {
    filters : {
        search : '',
		status : '',
        created : {
            from : '',
            to : ''
        },
    },
    options : {
        per_page   : 10,
        order_by   : 'created_at',
        order_type : 'desc'
    },
}
const getters = {
    filters : state => {
		return state.filters
    },

    options : state => {
		return state.options
    },

    per_page : (state, rootGetters) => {
		return rootGetters['page/per_page']
	},
}
const actions = {
    setOptions({ commit, dispatch }, options) {
        commit('setOptions', options)
    },

    setFilters({ commit, dispatch }, filters) {
        commit('setFilters', filters)
    },
    resetFilters({ commit, dispatch }, filters) {
        commit('setFilters', {
            search : '',
			status : '',
            created : {
                from : '',
                to : ''
            },
        })
    },   
    
    async get({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.get(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-danger border-danger'
			    }, {root:true});
				return Promise.reject(response.data)
			}

		} catch (e) {
			//return Promise.reject(e)
		}
    },
    
	async misc({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.misc(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-danger border-danger'
			    }, {root:true})
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async status({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.status(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				return Promise.reject(response.data)
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async getById({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.getById(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-danger border-danger'
			    }, {root:true});
				return Promise.reject(response.data)
			}

		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async delete({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.delete(context)
			if (response.data.status.success){
				return Promise.resolve(response.data)
			}else{
				dispatch('pnotify/alert', {
			        text: response.data.status.message,
			        addclass: 'bg-danger border-danger'
			    }, {root:true});
			}
		} catch (e) {
			//return Promise.reject(e)
		}
	},

	async downloadCSV({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.downloadCSV(context)
			dispatch('page/download', {
				data : response.data,
				type : 'text/csv;charset=utf-8;',
				name : 'heinz-entries-' + moment().format("DD-MM-YYYY") + '.csv',
			}, {root:true});
			return Promise.resolve('done')
		} catch (e) {
		}
	},

	async drawWinners({ commit, dispatch }, context) {
		try {
			const response = await heinzAPI.drawWinners(context)
			dispatch('page/download', {
				data : response.data,
				type : 'text/csv;charset=utf-8;',
				name : 'heinz-winners-' + moment().format("DD-MM-YYYY") + '.csv',
			}, {root:true});
			return Promise.resolve('done')
		} catch (e) {
		}
	},
}
const mutations = {
    setFilters(state, value) {
		state.filters = { ...value };		
    },

    setOptions(state, value) {
		state.options = { ...value };		
	}
}

/**
 * Export
 */
export default {
	namespaced: true,
	state,
	getters,
	actions,
    mutations
}
